import z from 'zod';

export const CommissionQuestionCheckStatusReqBodySchema = z.object({
  commissionRequestIds: z.array(z.string()),
});

export const CommissionQuestionReqQuerySchema = z.object({
  commissionRequestId: z.string(),
});
